(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/chat/chat-ui/assets/javascripts/chat-admin-component.js') >= 0) return;  svs.modules.push('/components/chat/chat-ui/assets/javascripts/chat-admin-component.js');


'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const chatUiMockable = svs.components.chat.chatUi;
const socketMockable = svs.components.lbUtils.socket;
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useCallback = _React.useCallback;
const _svs$components$chat$ = svs.components.chat.chatUi,
  logger = _svs$components$chat$.logger,
  ChatAdminBlockedContainer = _svs$components$chat$.ChatAdminBlockedContainer;
const _svs$components$chat$2 = svs.components.chat.chatData,
  helpers = _svs$components$chat$2.helpers,
  constants = _svs$components$chat$2.constants;
const MESSAGE_STATUS_SEND_PENDING = constants.MESSAGE_STATUS_SEND_PENDING,
  MESSAGE_STATUS_SEND_FAILED = constants.MESSAGE_STATUS_SEND_FAILED,
  MESSAGE_STATUS_SENT = constants.MESSAGE_STATUS_SENT,
  MESSAGE_STATUS_DELETE_PENDING = constants.MESSAGE_STATUS_DELETE_PENDING,
  MESSAGE_STATUS_DELETE_FAILED = constants.MESSAGE_STATUS_DELETE_FAILED,
  MESSAGE_STATUS_DELETED = constants.MESSAGE_STATUS_DELETED,
  MESSAGE_STATUS_NORMAL = constants.MESSAGE_STATUS_NORMAL,
  MESSAGE_STATUS_EDITED = constants.MESSAGE_STATUS_EDITED,
  MESSAGE_STATUS_INFO = constants.MESSAGE_STATUS_INFO,
  MAX_CHARACTER_COUNT = constants.MAX_CHARACTER_COUNT;
const ChatAdminComponent = _ref => {
  let canEditUser = _ref.canEditUser,
    onInitializeComponent = _ref.onInitializeComponent,
    visible = _ref.visible,
    onMarkRead = _ref.onMarkRead,
    messageList = _ref.messageList,
    roomId = _ref.roomId,
    onFetchMessages = _ref.onFetchMessages,
    onGetUnread = _ref.onGetUnread,
    onSocketUpdate = _ref.onSocketUpdate,
    newMessage = _ref.newMessage,
    onSubmitMessage = _ref.onSubmitMessage,
    children = _ref.children,
    error = _ref.error,
    onUnblockUser = _ref.onUnblockUser,
    hasLoadedEverything = _ref.hasLoadedEverything,
    loading = _ref.loading,
    onDeleteMessage = _ref.onDeleteMessage,
    onBlockUser = _ref.onBlockUser,
    onDeleteQueuedMessage = _ref.onDeleteQueuedMessage,
    onResendMessage = _ref.onResendMessage,
    isEnabled = _ref.isEnabled,
    activeTab = _ref.activeTab,
    onGetBlockedUsers = _ref.onGetBlockedUsers,
    onShowDialog = _ref.onShowDialog;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubscribed = _useState2[0],
    setSubscribed = _useState2[1];
  useEffect(() => {
    onInitializeComponent();
  }, []);
  useEffect(() => {
    if (visible) {
      const newServerMsgs = messageList.filter(m => !m.localId);
      const newLastId = (newServerMsgs.pop() || {}).id;
      if (newLastId) {
        onMarkRead(newLastId);
      }
    }
  }, [visible, onMarkRead]);
  const hasLogged = useRef(false);
  useEffect(() => {
    if (!hasLogged.current) {
      messageList.length > 100 && logger.warn("Client has many messages, roomId: ".concat(roomId, ", ").concat(messageList.length, " "));
      hasLogged.current = true;
    }
  }, [roomId]);
  const messageListRef = useRef();
  function handleOnChange() {
    messageListRef.current.scrollToBottom();
  }
  function handleSocketUpdate() {
    onSocketUpdate(...arguments);
    if (!isSubscribed) {
      onFetchMessages({
        reset: true
      });
      onGetUnread();
      setSubscribed(true);
    }
  }
  const validationError = helpers.validateChatMessage(newMessage, MAX_CHARACTER_COUNT);
  const handleFetchBlockedUsers = useCallback(() => {
    onGetBlockedUsers(roomId);
  }, [onGetBlockedUsers, roomId]);
  return React.createElement(socketMockable.Socket, {
    onUpdate: handleSocketUpdate,
    path: "/chat/1/rooms/retailer/".concat(roomId, "/messages/changes"),
    sendInitialUpdate: true
  }, _ref2 => {
    let socketError = _ref2.error,
      retryReconnect = _ref2.retryReconnect;
    return React.createElement("section", {
      className: "chat-container"
    }, children, React.createElement("div", {
      className: "chat-content"
    }, activeTab === 'chat' && React.createElement(React.Fragment, null, !isEnabled && React.createElement("div", {
      className: "fc-red align-center padding-2"
    }, "Kommentarsf\xE4ltet \xE4r inaktiverat och visas inte f\xF6r kunderna"), React.createElement(chatUiMockable.MessageList, {
      canEditUser: canEditUser,
      error: error || (socketError ? new Error('Kunde inte ansluta till chatten för tillfället') : null),
      hasLoadedEverything: hasLoadedEverything,
      isEnabled: isEnabled,
      loading: loading || !isSubscribed && !socketError,
      messageList: messageList,
      onBlockUser: onBlockUser,
      onDeleteMessage: onDeleteMessage,
      onDeleteQueuedMessage: onDeleteQueuedMessage,
      onFetchMessages: onFetchMessages,
      onResendMessage: onResendMessage,
      onRetryReconnect: error ? onFetchMessages : retryReconnect,
      ref: messageListRef
    })) || null, activeTab === 'chat' && isEnabled && React.createElement(chatUiMockable.WriteMessage, {
      disabled: Boolean(validationError),
      newMessage: newMessage,
      onSubmitMessage: onSubmitMessage,
      onUpdateNewMessage: handleOnChange
    }) || null, activeTab === 'blocked' && React.createElement(ChatAdminBlockedContainer, {
      onFetchBlockedUsers: handleFetchBlockedUsers,
      onShowDialog: onShowDialog,
      onUnblockUser: onUnblockUser,
      roomId: roomId
    }) || null));
  });
};
ChatAdminComponent.defaultProps = {
  isEnabled: true,
  messageList: [],
  newMessage: '',
  onInitializeComponent: () => {}
};
setGlobal('svs.components.chat.chatUi.ChatAdminComponent', ChatAdminComponent);

 })(window);